"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import Managerment from "@/views/managements/Managerment.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import _ from "lodash";
import MyTeamItem from "@/views/managements/teammanager/components/MyTeamItem.vue";
import TeamSettings from "@/views/managements/teammanager/components/TeamSettings.vue";
import { LayoutUI } from "@/components/layout/Layout.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
import MumbersAudit from "@/views/managements/teammanager/components/MumbersAudit.vue";
import DepartManage from "@/views/managements/teammanager/components/DepartManage.vue";
import TeamIJoined from "@/views/managements/teammanager/components/TeamIJoined.vue";
import TeamLoginController from "@/views/managements/teammanager/components/TeamLoginController.vue";
import RequestController from "@/views/managements/teammanager/components/RequestController.vue";
import PassRequestController from "@/views/managements/teammanager/components/PassRequestController.vue";
import RefuseRequestController from "@/views/managements/teammanager/components/RefuseRequestController.vue";
import BlackListRequestController from "@/views/managements/teammanager/components/BlackListRequestController.vue";
import RoleManage from "@/views/managements/teammanager/components/RoleManage.vue";
import i18n from "@/lang";
const UUID = require("uuid");
let TeamManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "myTeamItem",
          icon_image: "team_sidebar_1",
          name: i18n.t("team_management.my_team_item_sidebar")
        },
        {
          index: "teamSettings",
          icon_image: "team_sidebar_2",
          name: i18n.t("team_management.team_setting_sidebar")
        },
        {
          index: "mumberAudit",
          icon_image: "team_sidebar_3",
          name: i18n.t("team_management.mumber_audit_sidebar")
        },
        {
          index: "departManage",
          icon_image: "team_sidebar_4",
          name: i18n.t("team_management.department_manage_sidebar")
        },
        {
          index: "teamIJoined",
          icon_image: "team_sidebar_5",
          name: i18n.t("team_management.team_i_joined_sidebar")
        },
        {
          index: "TeamLoginController",
          icon_image: "safety_sidebar_1",
          name: i18n.t("safe_management.team_login_sidebar")
        },
        {
          index: "TeamLoginRequest",
          icon_image: "safety_sidebar_2",
          name: i18n.t("safe_management.team_login_request_sidebar"),
          sub_menus: [
            {
              index: "request",
              name: i18n.t("safe_management.team_wait_sidebar")
            },
            {
              index: "pass",
              name: i18n.t("safe_management.team_pass_sidebar")
            },
            {
              index: "refuse",
              name: i18n.t("safe_management.team_refuse_sidebar")
            },
            {
              index: "blacklist",
              name: i18n.t("safe_management.team_blacklist_sidebar")
            }
          ]
        }
      ],
      "myTeamItem"
    );
    this.default_components = "";
    this.mumber_autid_key = "";
  }
  created() {
    return __async(this, null, function* () {
      this.default_components = "myTeamItem";
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e;
      if (((_a = this.$session) == null ? void 0 : _a.type) !== "account") {
        this.menu_controller = new MenuController(
          false,
          [
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.is("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "myTeamItem",
                    icon_image: "team_sidebar_1",
                    name: i18n.t("team_management.my_team_item_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2, _b2;
              if (((_a2 = this.$session) == null ? void 0 : _a2.permissions.is("SHOW_ALL_MENUS")) && ((_b2 = this.$session) == null ? void 0 : _b2.marks.is("CLASSIC_ROLE_STYLE"))) {
                return [
                  {
                    index: "roleManage",
                    icon_image: "team_sidebar_3",
                    name: i18n.t("role_management.role_manage_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "teamSettings",
                    icon_image: "team_sidebar_2",
                    name: i18n.t("team_management.team_setting_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "mumberAudit",
                    icon_image: "team_sidebar_3",
                    name: i18n.t("team_management.mumber_audit_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "departManage",
                    icon_image: "team_sidebar_4",
                    name: i18n.t("team_management.department_manage_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "teamIJoined",
                    icon_image: "team_sidebar_5",
                    name: i18n.t("team_management.team_i_joined_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any(
                "TEAM_LOGIN_SETTING",
                "SHOW_ALL_MENUS"
              )) {
                return [{
                  index: "TeamLoginController",
                  icon_image: "safety_sidebar_1",
                  name: i18n.t("safe_management.team_login_sidebar")
                }];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any(
                "TEAM_LOGIN_APPROVAL",
                "SHOW_ALL_MENUS"
              )) {
                return [{
                  index: "TeamLoginRequest",
                  icon_image: "safety_sidebar_2",
                  name: i18n.t(
                    "safe_management.team_login_request_sidebar"
                  ),
                  sub_menus: [
                    {
                      index: "request",
                      name: i18n.t("safe_management.team_wait_sidebar")
                    },
                    {
                      index: "pass",
                      name: i18n.t("safe_management.team_pass_sidebar")
                    },
                    {
                      index: "refuse",
                      name: i18n.t(
                        "safe_management.team_refuse_sidebar"
                      )
                    },
                    {
                      index: "blacklist",
                      name: i18n.t(
                        "safe_management.team_blacklist_sidebar"
                      )
                    }
                  ]
                }];
              } else {
                return [];
              }
            })()
          ],
          ((_b = this.$session) == null ? void 0 : _b.permissions.is("SHOW_ALL_MENUS")) ? "myTeamItem" : ((_c = this.$session) == null ? void 0 : _c.permissions.is("TEAM_LOGIN_SETTING")) ? "TeamLoginController" : "request"
        );
        this.default_components = ((_d = this.$session) == null ? void 0 : _d.permissions.is("SHOW_ALL_MENUS")) ? "myTeamItem" : ((_e = this.$session) == null ? void 0 : _e.permissions.is("TEAM_LOGIN_SETTING")) ? "TeamLoginController" : "request";
      } else {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "myTeamItem",
              icon_image: "team_sidebar_1",
              name: i18n.t("team_management.my_team_item_sidebar")
            },
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.marks.is("CLASSIC_ROLE_STYLE")) {
                return [
                  {
                    index: "roleManage",
                    icon_image: "team_sidebar_3",
                    name: i18n.t("role_management.role_manage_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            {
              index: "teamSettings",
              icon_image: "team_sidebar_2",
              name: i18n.t("team_management.team_setting_sidebar")
            },
            {
              index: "mumberAudit",
              icon_image: "team_sidebar_3",
              name: i18n.t("team_management.mumber_audit_sidebar")
            },
            {
              index: "departManage",
              icon_image: "team_sidebar_4",
              name: i18n.t("team_management.department_manage_sidebar")
            },
            {
              index: "teamIJoined",
              icon_image: "team_sidebar_5",
              name: i18n.t("team_management.team_i_joined_sidebar")
            },
            {
              index: "TeamLoginController",
              icon_image: "safety_sidebar_1",
              name: i18n.t("safe_management.team_login_sidebar")
            },
            {
              index: "TeamLoginRequest",
              icon_image: "safety_sidebar_2",
              name: i18n.t("safe_management.team_login_request_sidebar"),
              sub_menus: [
                {
                  index: "request",
                  name: i18n.t("safe_management.team_wait_sidebar")
                },
                {
                  index: "pass",
                  name: i18n.t("safe_management.team_pass_sidebar")
                },
                {
                  index: "refuse",
                  name: i18n.t("safe_management.team_refuse_sidebar")
                },
                {
                  index: "blacklist",
                  name: i18n.t("safe_management.team_blacklist_sidebar")
                }
              ]
            }
          ],
          "myTeamItem"
        );
      }
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.default_components = _index.index;
        }
      }
    });
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.default_components = data;
    }
  }
  changeCollapse() {
    this.mumber_autid_key = UUID.v4();
  }
  showDrawer() {
    LayoutUI.showDrawer("rtl");
  }
};
TeamManager = __decorateClass([
  Component({
    components: {
      Managerment,
      MenuItem,
      MyTeamItem,
      RoleManage,
      TeamSettings,
      MainView,
      UiMenuBar,
      MumbersAudit,
      DepartManage,
      TeamIJoined,
      TeamLoginController,
      RequestController,
      PassRequestController,
      RefuseRequestController,
      BlackListRequestController
    }
  })
], TeamManager);
export {
  TeamManager as default
};
